import { api, apiUrl } from "../../shared/services/service";
import type {
  AdminPnlFilters,
  AdminPnlListResult,
  AdminPnlPreview,
  AdminPnlSyncRequest,
  AdminPnlSyncResult,
  AdminPnlTarget,
} from "../models/admin-pnl.models";
import axios from "axios";

export async function getAdminPnlRows(filters: AdminPnlFilters, signal: AbortSignal): Promise<AdminPnlListResult> {
  const response = await api.get<AdminPnlListResult>(`${apiUrl}/admin/debug/voyage-pnl`, { params: filters, signal });
  return response.data;
}

export async function previewAdminPnlSync(target: AdminPnlTarget, signal: AbortSignal): Promise<AdminPnlPreview> {
  const response = await api.post<AdminPnlPreview>(`${apiUrl}/admin/debug/voyage-pnl/preview`, target, { signal });
  return response.data;
}

export async function syncAdminPnlNames(request: AdminPnlSyncRequest): Promise<AdminPnlSyncResult> {
  const response = await api.post<AdminPnlSyncResult>(`${apiUrl}/admin/debug/voyage-pnl/sync-name`, request);
  return response.data;
}

export function getAdminPnlErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { error?: string; message?: string } | string | undefined;
    return typeof data === "string" ? data : data?.error ?? data?.message ?? error.message;
  }
  return error instanceof Error ? error.message : "PnL support request failed.";
}
